import {
  getRelativeFontSize,
  boldFont,
  PrimaryTextColor,
  regularFont,
  PrimaryLightTextColor,
} from "../../../../../utils/styles";

const PersonalDetailsStyles = {
  personalWrapper: {},
  pageInfoHeader: {
    position: "absolute",
    left: "130px",
    top: "30px",
  },

  Heading: {
    ...boldFont,
    fontSize: getRelativeFontSize(10),
  },
  text1: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
  },
  HeadingForm: {
    fontFamily: "Inter_Bold",
  fontWeight: 700,
  paddingBottom:'20px',

    fontSize: getRelativeFontSize(10),
  },
  text: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },

  header: {
    paddingBottom: "30px ",
    marginTop: 5,
  },
  pageHeading: {
    fontSize: getRelativeFontSize(2),
    ...boldFont,
    color: PrimaryTextColor,
  },
  pageText: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },
  avtarStyle: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    border: "4px solid #ECEDFC",
    //  overflow: "hidden",
    padding: "5px",
    position: " relative",
    "& img": {
      width: "100%",
      height: " auto",
      overflow: "hide",
    },
  },

  uploadIcon: {
    position: " absolute",
    bottom: "-15px",
    right: "-10px",
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    background: "#ECEDFC",
  },
  custombuttonStyle: {
    width: "200px",
  },

  label: {
    ...regularFont,
    fontSize: getRelativeFontSize(),
    wordSpacing: "2px",
    color: PrimaryTextColor,
  },

  autocomplateStyle: {
    width: "100%",
    background: "#fffff",
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(2),
      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(-1),
        color: PrimaryLightTextColor,
      },
    },
    "&  .MuiOutlinedInput-root": {
      padding: "4px 9px !important",
    },
    "& .MuiAutocomplete-input":{
      padding: "4px 9px 3px !important",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
  },

  avatarContainer: {
    position: "relative",
    width: 70,
    height: 70,
    borderRadius: "50%",
    border: "4px solid #ECEDFC",
    overflow: "hidden",
    padding: "5px",
  },
  cameraIcon: {
    position: "absolute",
    bottom: 0,
    right: 0,
    transform: "translate(25%, 40%)",
    // backgroundColor: theme.palette.common.white,
    borderRadius: "50%",
    padding: 4,
    cursor: "pointer",
    zIndex: 2,
    width: "20px",
    height: "20px",
  },
  fileInput: {
    display: "none",
  },

  profileContainer: {
    position: "relative",
    zIndex: 9,
    width: "100px",
  },
  profile: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    overflow: "hidden",
    zIndex: 9,
    border: "4px solid #ECEDFC",
    display: "flex",
    alignItem: "center",
    justifyContent: "center",

    "& img": {
      width: "100%",
      height: "auto",
    },
  },
  uploadCameraIcon: {
    position: "absolute",
    bottom: "-9px",
    right: "10px",
    zIndex: 9999,
    background: "#ECEDFC",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      height: "10px",
      width: "10px",
    },
  },

  autoInputBlank: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
      fontSize: getRelativeFontSize(),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
    "& .MuiAutocomplete-input": {
      fontSize: getRelativeFontSize(),
      padding:"4px 5px",
    },
  },

  autoInputFill: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
      fontSize: getRelativeFontSize(),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
    "& .MuiAutocomplete-inputFocused": {
      fontSize: getRelativeFontSize(2),
    },
  },

  startText: {
    ...regularFont,
    fontSize: getRelativeFontSize(0),
    borderRight: "1px solid #ccc",
    paddingRight: "10px",
  },

  customPaddingLeft: {
    "& .MuiInputBase-input": {
      paddingLeft: "0",
    },
  },
};

export default PersonalDetailsStyles;
